const reducer = (state, action) => {

    switch (action.type) {
        case "SET_EXCEL_FILE": {
            return { ...action.payload };
        }

        case "CLEAR_EXCEL_FILE": {
            return {};
        }

        default: {
            return state;
        }
    }
};

export default reducer;
